import React from 'react';
import { SummaryLayout } from 'quanta-ui';
// import { Layout, ClientService } from '../../../../lib/layout/index';
import SummaryPanel from './summary-panel';
import WizardPanel from './wizard-panel';
import { useParams } from 'react-router-dom';
import { Layout,ClientService } from 'quanta-flows/modules/layout';
import { PRODUCT_TYPE_LIST } from './queries';
import { useQuery } from '@apollo/client';
import { Loading } from 'quanta-flows/modules/layout';
export default function NewMotorPolicyIssuance({
  startStep,
  isProposalNumberGenerated,
  customerID,
  lobCode,
  lobName,
  productName,
  productCode,
  proposalNumber,
  stepsDisabled,
  breadcrumbNav,
  productType,
}) {
  const {
    loading: loadingLobList,
    error: errorLobList,
    data: dataLobList,
  } = useQuery(PRODUCT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
  });
  if (loadingLobList) {
    return <Loading />;
  }
  const { lobProductList } = dataLobList;

  let nav = ['Quote', 'Buy Policy'];
  const params = useParams();
  const lob_code = params?.lob_code ? params?.lob_code : lobCode;
  const lob_name = params?.lob_name ? params?.lob_name : lobName;
  const product_code = params?.product_code
    ? params?.product_code
    : productCode;
  const product_name = params?.product_name
    ? params?.product_name
    : productName;
  const product_type = params?.product_type
    ? params?.product_type
    : productType;
const display_name=(lobProductList
  ?.find(
    (lob) =>
      lob?.lob_code?.toString()?.toLowerCase() ===
      lob_code?.toString()?.toLowerCase(),
  )
  ?.products?.find(
    (product) =>
      product?.product_code?.toString()
      ===
        product_code?.toString()
  )?.display_name
);
  return (
    <Layout
      nav={breadcrumbNav ? breadcrumbNav : nav}
      service_type={ClientService}
      title={`Your ${display_name?display_name:product_name} Proposal`}
    >
      <SummaryLayout
        summary={
          <SummaryPanel
            {...{
              productName: product_name,
              productType: product_type,
              productCode: product_code,
              lobCode: lob_code,
              lobName: lob_name,
            }}
          />
        }
      >
        <WizardPanel
          {...{
            isProposalCreated: isProposalNumberGenerated,
            productName: product_name,
            productType: product_type,
            productCode: product_code,
            lobCode: lob_code,
            lobName: lob_name,
            startStep,
            proposalNumber,
            stepsDisabled,
          }}
        />
      </SummaryLayout>
      <div className="bg-neutral sticky bottom-0 p-3 -mx-4 mt-2 -mb-4 xl:hidden z-40">
        <SummaryPanel
          {...{
            productName: product_name,
            productType: product_type,
            productCode: product_code,
            lobCode: lob_code,
            lobName: lob_name,
          }}
        />
      </div>
    </Layout>
  );
}
